import { wrapFetch } from '../libs/fetch';
import { Tvsinfo } from '../types/tvs';
import { TvDetail, RelatedTvs } from '../types/tvShow';

export const getTvsInfo = async (kw: string) => {
  return await wrapFetch<Tvsinfo>(`/api/v1/tvs${kw ? `/search?keyword=${encodeURIComponent(kw)}` : ''}`);
};

export const getTvDetail = async (id: number) => {
  return await wrapFetch<TvDetail>(`/api/v1/tvs/${id}`);
};

export const getRelatedTvs = async (id: number) => {
  return await wrapFetch<RelatedTvs>(`/api/v1/tvs/${id}/related`);
};
